import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Grid, Typography } from '@material-ui/core';

import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import SendEmail from '../Components/SendEmail.component';

const PaymentPerDay = () => {
  //   const { user } = useAuthDataContext();
  const { loading, vehicle, policy, getPolicyById } = useVehiclesContext();
  const { id }: any = useParams();
  const history = useHistory();
  const { user } = useAuthDataContext();

  useEffect(() => {
    dataLayerPush('Documentacion_certificado_pagos_al_dia', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id) {
      if (policy.id !== Number(id)) {
        getPolicyById(id);
      }
    } else {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const TO_SHOW = [
    {
      title: 'Forma de pago',
      content: policy?.payment_type_name,
    },
    {
      title: 'Estado de pago',
      content: 'Al día',
    },
    {
      title: 'Modelo',
      content: vehicle ? vehicle.model.split(' ')[0] : '',
    },
    {
      title: 'Versión',
      content: vehicle ? vehicle.model.split(' ').slice(1).join(' ') : '',
    },
  ];

  return Object.keys(policy).length ? (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando póliza'}></Loader>
      </Box>

      <SubHeader
        content={
          <>
            <Typography>Certificado de pagos al día</Typography>
            <Typography variant="h6" color="primary">
              {vehicle.brand +
                ' ' +
                vehicle.model.split(' ')[0] +
                ' ' +
                vehicle.year +
                ' / ' +
                vehicle.license_plate}
            </Typography>{' '}
            <Typography variant="caption">
              Es el documento que certifica que estás al día con los pagos.
            </Typography>
          </>
        }
        actions={<SendEmail documentType={'payments_per_day'}></SendEmail>}
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11} sm={10} lg={8}>
          {/* VEHCILE INFO */}
          <Grid container>
            {TO_SHOW.map((item: any, index: number) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box style={{ marginTop: '24px', marginBottom: '4px' }}>
                  <Typography variant="caption">{item.title}</Typography>
                </Box>
                <Box>
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    {item.content}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  ) : null;
};

export default PaymentPerDay;
